'use client';
import { SignIn } from '@clerk/nextjs';
import { registerDialogParser } from '@dolcevia/lib/searchParams';
import { buttonVariants } from '@dolcevia/ui/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '@dolcevia/ui/components/ui/dialog';
import { useTranslations } from 'next-intl';
import { useQueryState } from 'nuqs';

export const SignInDialog = () => {
  const t = useTranslations('Login');
  const [forceDialog, setForceDialog] = useQueryState(
    'forceDialog',
    registerDialogParser,
  );

  return (
    <Dialog open={forceDialog} onOpenChange={(open) => setForceDialog(open)}>
      <DialogTrigger
        className={buttonVariants({ variant: 'default', size: 'default' })}
      >
        {t('Se connecter')}
      </DialogTrigger>
      <DialogContent
        className="w-auto bg-transparent border-0 shadow-none"
        hideCloseButton
      >
        <SignIn routing="hash" />
      </DialogContent>
    </Dialog>
  );
};
